<script>
import { ArrowUpRightIcon } from 'lucide-vue-next'

export const NEW_PORTAL_URL = 'https://askcpg.qmed.ai/'

export default {
  name: 'NewPortalNotice',
  components: { ArrowUpRightIcon },
  data() {
    return {
      portalUrl: NEW_PORTAL_URL
    }
  }
}
</script>

<template>
  <header class="portal-bar" role="banner">
    <span class="portal-bar-spacer" aria-hidden="true"></span>
    <a
      :href="portalUrl"
      class="portal-bar-cta"
      target="_blank"
      rel="noopener noreferrer"
    >
      AskCPG has a new look
      <arrow-up-right-icon :size="15" :stroke-width="2.25" />
    </a>
    <div class="portal-bar-aside">
      <slot name="aside" />
    </div>
  </header>
</template>

<style scoped>
.portal-bar {
  position: sticky;
  top: 0;
  z-index: 40;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  min-height: 56px;
  padding: 0 1rem;
  background: #231f20;
  color: #fff;
}

.portal-bar-spacer {
  justify-self: start;
}

.portal-bar-cta {
  justify-self: center;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  height: 36px;
  padding: 0 1.15rem 0 1.25rem;
  border-radius: 999px;
  background: #0fbab2;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1;
  text-decoration: none;
  white-space: nowrap;
  box-shadow: 0 0 0 0 rgba(15, 186, 178, 0.55);
  animation: cta-pulse 1.8s ease-in-out infinite;
  transition: background-color 160ms cubic-bezier(0.2, 0, 0.2, 1), transform 120ms ease;
}

.portal-bar-cta:hover,
.portal-bar-cta:focus-visible {
  animation: none;
  background: #12d0c7;
  color: #fff;
  transform: scale(1.04);
}

.portal-bar-cta:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.35);
}

.portal-bar-aside {
  justify-self: end;
  display: flex;
  align-items: center;
}

.portal-bar-aside :deep(.theme-toggle) {
  position: static;
  width: 34px;
  height: 34px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.16);
}

.portal-bar-aside :deep(.theme-toggle:hover) {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.32);
}

.portal-bar-aside :deep(.theme-icon) {
  color: #fff;
}

@keyframes cta-pulse {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(15, 186, 178, 0.7);
    transform: scale(1);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(15, 186, 178, 0);
    transform: scale(1.06);
  }
}

@media (max-width: 640px) {
  .portal-bar {
    min-height: 52px;
    padding: 0 0.7rem 0 0.85rem;
  }

  .portal-bar-cta {
    height: 32px;
    padding: 0 0.85rem;
    font-size: 13px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .portal-bar-cta {
    animation: none;
  }
}
</style>
